import type {
  Automation,
  AutomationActionTypes,
  AutomationUpdateInput,
  GetListedAutomationsRequestData,
  ListedAutomationsListViewPage,
} from '@payaca/types/automationTypes';
import { action } from 'typesafe-actions';
import { ActionType } from './automationTypes';

export const requestGetListedAutomationsPage = (
  getListedAutomationsRequestData: GetListedAutomationsRequestData,
  callback?: (
    listedAutomationsListViewPage: ListedAutomationsListViewPage
  ) => void
) => {
  return action(ActionType.REQUEST_GET_LISTED_AUTOMATIONS_PAGE, {
    getListedAutomationsRequestData,
    callback,
  });
};

export const getListedAutomationsPageSuccess = (
  listedAutomationsListViewPage: ListedAutomationsListViewPage
) => {
  return action(
    ActionType.GET_LISTED_AUTOMATIONS_PAGE_SUCCESS,
    listedAutomationsListViewPage
  );
};

export const getListedAutomationsPageFailure = (error: Error) => {
  return action(
    ActionType.GET_LISTED_AUTOMATIONS_PAGE_FAILURE,
    null,
    null,
    error
  );
};

export const requestGetAutomation = (automationId: number) => {
  return action(ActionType.REQUEST_GET_AUTOMATION, { automationId });
};

export const getAutomationSuccess = (
  automationId: number,
  automation: Automation<AutomationActionTypes>
) => {
  return action(ActionType.GET_AUTOMATION_SUCCESS, {
    automationId,
    automation,
  });
};

export const getAutomationFailure = (automationId: number, error: Error) => {
  return action(ActionType.GET_AUTOMATION_FAILURE, automationId, null, error);
};

export const requestCreateAutomation = (
  callback?: (automationId: number) => void,
  onError?: (error: Error) => void
) => {
  return action(ActionType.REQUEST_CREATE_AUTOMATION, {
    callback,
    onError,
  });
};

export const createAutomationSuccess = (automationId: number) => {
  return action(ActionType.CREATE_AUTOMATION_SUCCESS, automationId);
};

export const createAutomationFailure = (error: Error) => {
  return action(ActionType.CREATE_AUTOMATION_FAILURE, null, error);
};

export const requestUpdateAutomation = (
  automationId: number,
  automationUpdates: AutomationUpdateInput<AutomationActionTypes>,
  callback?: (automation: Automation<AutomationActionTypes>) => void,
  onError?: (error: Error) => void
) => {
  return action(ActionType.REQUEST_UPDATE_AUTOMATION, {
    automationId,
    automationUpdates,
    callback,
    onError,
  });
};

export const updateAutomationSuccess = (
  automationId: number,
  automation: Automation<AutomationActionTypes>
) => {
  return action(ActionType.UPDATE_AUTOMATION_SUCCESS, {
    automationId,
    automation,
  });
};

export const updateAutomationFailure = (automationId: number, error: Error) => {
  return action(
    ActionType.UPDATE_AUTOMATION_FAILURE,
    automationId,
    null,
    error
  );
};

export const requestArchiveAutomations = (
  automationIds: number[],
  onArchiveSuccess?: any
) => {
  return action(ActionType.REQUEST_ARCHIVE_AUTOMATIONS, {
    automationIds,
    onArchiveSuccess,
  });
};

export const archiveAutomationsSuccess = () => {
  return action(ActionType.ARCHIVE_AUTOMATIONS_SUCCESS);
};

export const archiveAutomationsFailure = (error: Error) => {
  return action(ActionType.ARCHIVE_AUTOMATIONS_FAILURE, null, error);
};

export const clearAutomations = () => {
  return action(ActionType.CLEAR_AUTOMATIONS);
};
